export const LOGIN = "/login";

export const USER = "/user";
export const USER_DETAIL = "/user/detail";

export const INSTITUTION = "/institution";
export const INSTITUTION_DETAIL = "/institution/detail";
export const NOTICE = "/notice";
export const NOTICE_WRITE = "/notice/write";

export const INQUIRY = "/inquiry";
export const INQUIRY_DETAIL = "/inquiry/detail";

export const FAQ = "/FAQ";
export const FAQ_DETAIL = "/FAQ/detail";

export const LECTURE = "/lecture";
export const LECTURE_LISTENER = "/lecture/listener";
export const LECTURE_DETAIL = "/lecture/detail";

export const LICENSE = "/license";
export const LICENSE_DETAIL = "/license/detail";
export const PAYMENT = "/payment";
export const PAYMENT_DETAIL = "/payment/detail";